module.exports = __webpack_public_path__ + "img/report-10.69aae7bc.jpg";